import { render, staticRenderFns } from "./newSaleContract.vue?vue&type=template&id=4f067c8c&scoped=true"
import script from "./newSaleContract.vue?vue&type=script&lang=js"
export * from "./newSaleContract.vue?vue&type=script&lang=js"
import style0 from "./newSaleContract.vue?vue&type=style&index=0&id=4f067c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f067c8c",
  null
  
)

export default component.exports